/**
 * Connects data from the BE to the FE composable
 */
function parseFeatureFlags() {
    try {
        if (import.meta.env.VITE_APP_ENV === 'testing') {
            return JSON.parse(window.CYPRESS_FEATURE_FLAGS);
        }
        return JSON.parse(document.body.dataset?.featureFlags ?? '{}');
    } catch {
        return {};
    }
}

// Supplies the data to vue components
export function useFeatureFlags() {
    return parseFeatureFlags();
}

export function useFeatureFlag(key) {
    if (!key) throw new Error('Missing parameter "key" for feature flag');

    return parseFeatureFlags()[key];
}

export function isFeatureFlagDefined(key: string): boolean {
    return key in useFeatureFlags();
}

export function isFeatureActive(key: string): boolean {
    return Boolean(useFeatureFlag(key));
}
